import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="pdf-export-summary-flag"
// Hides the "non renseigné" flag on the summary line while the note
// section is open, and restores it on close when the note is still empty.
// Also hides the summary section when the current_state report template is selected.
export default class extends Controller {
  static targets = ['flag', 'section', 'input', 'summaryWrapper', 'templateRadio']
  static values = { currentStateTemplate: { type: String, default: 'current_state' } }

  connect () {
    this.updateSummaryVisibility()
  }

  toggle () {
    if (this.sectionTarget.open) {
      this.hideFlags()
    } else if (this.inputBlank()) {
      this.showFlags()
    }
  }

  updateSummaryVisibility () {
    if (!this.hasSummaryWrapperTarget) return

    this.summaryWrapperTarget.hidden = this.currentStateTemplateSelected()

    if (this.currentStateTemplateSelected()) return

    if (this.hasSectionTarget && this.sectionTarget.open) {
      this.hideFlags()
    } else if (this.inputBlank()) {
      this.showFlags()
    }
  }

  hideFlags () {
    this.flagTargets.forEach((flag) => flag.classList.add('hidden'))
  }

  showFlags () {
    this.flagTargets.forEach((flag) => flag.classList.remove('hidden'))
  }

  inputBlank () {
    return !this.hasInputTarget || this.inputTarget.value.trim() === ''
  }

  currentStateTemplateSelected () {
    const selected = this.templateRadioTargets.find((radio) => radio.checked)
    return selected?.value === this.currentStateTemplateValue
  }
}
